<div *ngIf="imageUrl">
  <img [src]="imageUrl" class="img-fluid img-thumbnail" [alt]="getFileName(fileUrl)" />
</div>
<div *ngIf="!imageUrl">
  <p>Loading...</p>
</div>
